import { render, staticRenderFns } from "./OnlineAnswerCount.vue?vue&type=template&id=aadea8e8&scoped=true&"
import script from "./OnlineAnswerCount.vue?vue&type=script&lang=js&"
export * from "./OnlineAnswerCount.vue?vue&type=script&lang=js&"
import style0 from "./OnlineAnswerCount.vue?vue&type=style&index=0&id=aadea8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadea8e8",
  null
  
)

export default component.exports